<template>
  <div class="animated fadeIn">
    <b-card no-header>
      <b-form>
        <b-form-group
          label="Código"
          label-for="codigo"
          :label-cols="labelCols">
          <b-form-input id="codigo"
            v-model.trim="$v.codigo.$model"
            :state="codigoValido"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="codigoFeedback">
            {{ codigoInvalidoMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <b-form-group
          label="Nombre"
          label-for="nombre"
          :label-cols="labelCols">
          <b-form-input id="nombre"
            v-model.trim="$v.nombre.$model"
            :state="nombreValido"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="nombreFeedback">
            {{ nombreInvalidoMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <b-form-group
          label-for="honorarios"
          :label-cols="labelCols">
          <b-form-checkbox 
              id="honorarios"
              v-model="honorarios"
              value= true
              unchecked-value= false>
              Honorarios del Personal
          </b-form-checkbox>
        </b-form-group>
      </b-form>

      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button"
          @click.prevent="close">Cancelar</b-button>
      </div>
    </b-card>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, numeric, maxLength } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'rubro/getField',
  mutationType: 'rubro/updateField',
});

export default {
  name: 'RubroABM',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal, 
  ],
  props: {
    cuentaId: {
      type: Number,
      default: 0
    },
    rubroId: {
      type: Number,
      default: 0
    },
  },
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      codigoValido: null,
      codigoInvalidoMsj: '',
      nombreValido: null,
      nombreInvalidoMsj: '',

      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'id',
      'codigo',
      'nombre',
      'honorarios',
    ])
  },
  created() {
    let params = {
      cuentaId: this.cuentaId,
      rubroId: this.rubroId,
    }
    this.showSpinner();
    this.$store.dispatch('rubro/inicializar', params)
      .catch( error => this.showErrorMsj (error))
      .finally(() => this.hideSpinner());
  },
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {

          /* Formato del codigo de cuenta */
          if (event.target.id == 'codigo') {
            if (!isNaN(this.codigo)) {
              let numeroCodigo = parseInt(this.codigo);

              this.codigo = numeroCodigo.toString().padStart(3, '0');
            }
          }

          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'codigo' || validarTodos) {
        if (this.$v.codigo.$error) {
          this.codigoValido = false
          if (!this.$v.codigo.required) {
            this.codigoInvalidoMsj = 'Debe ingresar el código del rubro';
          } else if (!this.$v.codigo.numeric) {
            this.codigoInvalidoMsj = 'El código sólo puede contener dígitos numéricos.';
          } else if (!this.$v.codigo.maxLength) {
            this.codigoInvalidoMsj = 'El nombre sólo puede contener hasta 3 dígitos.';
          }      
        } else {
          this.codigoValido = null;
          this.codigoInvalidoMsj = '';
        }
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj = 'Debe ingresar el nombre del rubro.';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre sólo puede contener hasta 50 caracteres';
          }      
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        this.showSpinner();
        this.$store.dispatch('rubro/save')
          .then( () => this.showModalMsj ('Los cambios se registraron con éxito.', this.saved, this.saved, 'light'))
          .catch( error => this.showErrorMsj (error))
          .finally(() => this.hideSpinner());
      }
    },
    saved() {
      this.$emit('close', true);
    },
    close() {
      this.$emit('close', false);
    },
  },
  /* Vuelidate */
  validations: {
    codigo: {
      required,
      numeric,
      maxLength: maxLength(3)
    },
    nombre: {
      required,
      maxLength: maxLength(50)
    },
  },  
}
</script>

<style>
</style>
